/* MarieOdile — Community Fits coverflow.
   Sectie-gescoped, idempotent en bestand tegen Theme Editor section reloads.
   Kaarten zonder video blijven gewoon posters; kaarten met video krijgen
   werkende afspeel- en geluidsknoppen. */
(function () {
  'use strict';

  function initFits(root) {
    if (!root || root.dataset.moFitsInit === '1') return;
    root.dataset.moFitsInit = '1';

    var cards = [].slice.call(root.querySelectorAll('[data-mo-fitcard]'));
    var n = cards.length;
    if (!n) return;

    var offsetD = parseInt(root.dataset.offset, 10) || 298;
    var offsetM = parseInt(root.dataset.offsetMobile, 10) || 200;
    var sideScale = (parseInt(root.dataset.sideScale, 10) || 90) / 100;
    var farScale = (parseInt(root.dataset.farScale, 10) || 80) / 100;
    var breakpoint = parseInt(root.dataset.breakpoint, 10) || 768;
    var autoplay = root.dataset.autoplay === 'true';

    var start = (parseInt(root.dataset.start, 10) || 1) - 1;
    var active = Math.min(Math.max(start, 0), n - 1);

    function offset() {
      return window.innerWidth <= breakpoint ? offsetM : offsetD;
    }

    function layout() {
      var step = offset();
      cards.forEach(function (c, k) {
        var rel = ((k - active) % n + n) % n;
        var signed = rel <= n / 2 ? rel : rel - n;
        var scale = null;
        var z = 0;
        if (signed === 0) { scale = 1; z = 5; }
        else if (signed === -1 || signed === 1) { scale = sideScale; z = 4; }
        else if (signed === -2 || signed === 2) { scale = farScale; z = 3; }

        if (scale === null) {
          c.style.display = 'none';
          c.classList.remove('is-current');
        } else {
          c.style.display = '';
          c.style.zIndex = z;
          c.style.transform =
            'translate(calc(-50% + ' + signed * step + 'px), -50%) scale(' + scale + ')';
          c.classList.toggle('is-current', signed === 0);
        }
      });
      syncVideos();
    }

    /* Alleen de middelste video speelt; de rest pauzeert en dempt.
       Zo blijft er nooit geluid uit een half zichtbare kaart komen. */
    function syncVideos() {
      cards.forEach(function (c) {
        var v = c.querySelector('[data-mo-fits-video]');
        if (!v) return;
        if (c.classList.contains('is-current')) {
          if (autoplay && inView()) {
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
            c.classList.add('is-playing');
          }
        } else {
          v.pause();
          v.muted = true;
          c.classList.remove('is-playing', 'is-unmuted');
        }
      });
    }

    var visible = false;
    function inView() { return visible; }

    function go(delta) {
      active = (active + delta + n) % n;
      layout();
    }

    var prev = root.querySelector('[data-mo-fits-prev]');
    var next = root.querySelector('[data-mo-fits-next]');
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });

    /* Klik op een zijkaart brengt die naar voren */
    cards.forEach(function (c, k) {
      c.addEventListener('click', function (e) {
        if (e.target.closest('[data-mo-fits-play], [data-mo-fits-sound]')) return;
        if (k !== active) { active = k; layout(); }
      });
    });

    /* Afspelen en geluid per kaart */
    root.querySelectorAll('[data-mo-fits-play]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = btn.closest('[data-mo-fitcard]');
        var v = card.querySelector('[data-mo-fits-video]');
        if (!v) return;
        if (v.paused) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
          card.classList.add('is-playing');
        } else {
          v.pause();
          card.classList.remove('is-playing');
        }
      });
    });
    root.querySelectorAll('[data-mo-fits-sound]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = btn.closest('[data-mo-fitcard]');
        var v = card.querySelector('[data-mo-fits-video]');
        if (!v) return;
        v.muted = !v.muted;
        card.classList.toggle('is-unmuted', !v.muted);
      });
    });

    /* Pauzeer zodra de sectie uit beeld is: scheelt data en batterij */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (!visible) {
          cards.forEach(function (c) {
            var v = c.querySelector('[data-mo-fits-video]');
            if (v) { v.pause(); c.classList.remove('is-playing'); }
          });
        } else {
          syncVideos();
        }
      }, { threshold: 0.35 });
      io.observe(root);
      root.moFitsIO = io;
    } else {
      visible = true;
    }

    var resizeTimer = null;
    function onResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(layout, 120);
    }
    window.addEventListener('resize', onResize);

    root.moFitsDestroy = function () {
      if (root.moFitsIO) root.moFitsIO.disconnect();
      window.removeEventListener('resize', onResize);
      clearTimeout(resizeTimer);
      root.dataset.moFitsInit = '';
    };

    layout();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-mo-fits]').forEach(initFits);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else { initAll(); }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-mo-fits]').forEach(function (r) {
      if (typeof r.moFitsDestroy === 'function') r.moFitsDestroy();
    });
  });
})();
